import classes from './LoginPage.module.css';
import { useUserContext } from '../../contexts/UserContext';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import { SignInButton } from '../../components/ADLogin/SignInButton';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { useIsAuthenticated } from "@azure/msal-react";
import { login } from '../../scripts/dataHandlers';
import { useErrorContext } from '../../contexts/ErrorContext';

const LoginPage = () => {

    const { t } = useTranslation();

    const { setUser } = useUserContext();

    const [isError, setIsError] = useState<boolean>(false);

    const { handleError } = useErrorContext();

    const isAuthenticated = useIsAuthenticated();

    const loginProcess = async () => {
        console.log('loginProcess');
        let loginResponse = await login();
        console.log("LOGINRESP: ", loginResponse)

        if (loginResponse && // There has to be response (not undefined -> failed auth)
            (loginResponse.data.isDoctor || // Doctor is allowed to connect with or without units
                (loginResponse.data.isDoctor === false && loginResponse.data.units.length > 0) // If not doctor, there has to be some units
            )
        ) {
            // Set userData
            setUser({ ...loginResponse.data });
        } else {
            handleError(new Error("Authentication failed or user is not foreman of any expenseunit"), "AuthFailedOrNotForeman")
            setIsError(true);
        }
    };

    useEffect(() => {
        console.log('=========isAuthenticated', isAuthenticated);
        if (isAuthenticated) {
            loginProcess();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[isAuthenticated]);

    return (
        <div className={classes.pageContainer}>
            <div className={classes.introText}>
                {t('loginPage.introText')}
            </div>

            <AuthenticatedTemplate>
                {!isError ?
                    <div className={classes.loadingContainer}>
                        <ReactLoading type={"spokes"} color={"#ED1B24"} height={'50px'} width={'50px'} />
                        <div className={classes.loadingText}>{t('mainPage.loading')}</div>
                    </div>
                    :
                    <div>{t('mainPage.unableToLogin')}</div>
                }

            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <SignInButton></SignInButton>
            </UnauthenticatedTemplate>
        </div>
    )
};

export default LoginPage;